import { render } from "./GuessTheReferenceQuestion.vue?vue&type=template&id=5df6f8d8&scoped=true&ts=true"
import script from "./GuessTheReferenceQuestion.vue?vue&type=script&lang=ts"
export * from "./GuessTheReferenceQuestion.vue?vue&type=script&lang=ts"

import "./GuessTheReferenceQuestion.vue?vue&type=style&index=0&id=5df6f8d8&lang=postcss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df6f8d8"]])

export default __exports__